import { Route, Routes } from 'react-router-dom';

import ManagerPage from './manager-page';
import ManagersPage from './managers-page';

export default function Managers() {
    return (
        <Routes>
            <Route
                path="/"
                element={<ManagersPage />}
            />

            <Route
                path="/:id"
                element={<ManagerPage />}
            />
        </Routes>
    );
}